import { titleize } from '../titleize';

export const formatPageTitle = (title: string) =>
  [titleize(title), 'Moda Operandi'].filter(Boolean).join(' | ');
